import { LocalSeoHub } from '@/pages/local-seo/LocalLandingPages';

export default function KwiaciarniaLublinHub() {
  return <LocalSeoHub type="district" />;
}